import { motion } from "motion/react";
import { TestimonialsColumn } from "./ui/testimonials-columns-1";

const testimonials = [
  {
    text: "A complete rebuild in five days. The result outperformed everything we'd spent months building before. EsyAI understood our vision instantly.",
    image: "https://randomuser.me/api/portraits/women/1.jpg",
    name: "Sarah Chen",
    role: "CEO, Luminary",
  },
  {
    text: "Conversions up 4x. That's not a typo. The design just works differently when it's built on real data. Their AI automations changed our entire funnel.",
    image: "https://randomuser.me/api/portraits/men/2.jpg",
    name: "Marcus Webb",
    role: "Head of Growth, Arcline",
  },
  {
    text: "They didn't just design our site. They built our entire software stack -- tools, dashboards, and automations. World-class doesn't begin to cover it.",
    image: "https://randomuser.me/api/portraits/women/3.jpg",
    name: "Elena Voss",
    role: "Brand Director, Helix",
  },
  {
    text: "EsyAI built our entire CRM automation from scratch. Lead follow-ups, onboarding emails, and reporting — all running automatically. We've reclaimed 20 hours a week.",
    image: "https://randomuser.me/api/portraits/men/4.jpg",
    name: "Omar Raza",
    role: "Founder, ScaleIQ",
  },
  {
    text: "The AI chatbot EsyAI deployed handles 80% of our customer queries instantly. Response times went from hours to seconds. Our support team is now free to focus on complex cases.",
    image: "https://randomuser.me/api/portraits/women/5.jpg",
    name: "Priya Nair",
    role: "Head of Customer Experience, Brightly",
  },
  {
    text: "We needed a custom client portal built fast. EsyAI delivered a polished, fully integrated app in under two weeks. Our clients are obsessed with it.",
    image: "https://randomuser.me/api/portraits/women/6.jpg",
    name: "Aliza Khan",
    role: "Operations Director, Nexara",
  },
  {
    text: "Our Google rankings improved significantly within three months of EsyAI rebuilding our website. The SEO architecture they built in from day one has been a game-changer.",
    image: "https://randomuser.me/api/portraits/men/7.jpg",
    name: "James Hargreaves",
    role: "Marketing Manager, Vantage Digital",
  },
  {
    text: "EsyAI automated our entire invoice and payment reminder workflow. What used to take two days a week now runs on its own. The ROI was immediate.",
    image: "https://randomuser.me/api/portraits/women/8.jpg",
    name: "Ananya Sharma",
    role: "CFO, Horizon Retail",
  },
  {
    text: "The AI agents EsyAI built qualify and book our inbound leads automatically. Our sales team now only speaks to warm, pre-qualified prospects. Conversion rates are up 60%.",
    image: "https://randomuser.me/api/portraits/men/9.jpg",
    name: "Ryan Mitchell",
    role: "VP Sales, Foundry Labs",
  },
];

const firstColumn = testimonials.slice(0, 3);
const secondColumn = testimonials.slice(3, 6);
const thirdColumn = testimonials.slice(6, 9);

export default function Testimonials() {
  return (
    <section className="bg-black py-24 relative overflow-hidden" data-testid="testimonials-section">
      <div className="max-w-6xl mx-auto z-10 relative px-4 sm:px-8 lg:px-16">
        {/* Header - kept consistent with EsyAI styling */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false }}
            className="liquid-glass rounded-full px-3.5 py-1 inline-block mb-6"
          >
            <span className="text-xs font-medium text-white font-body">
              What They Say
            </span>
          </motion.div>
          
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false }}
            transition={{ delay: 0.1 }}
            className="text-4xl md:text-5xl lg:text-6xl font-heading italic text-white tracking-tight leading-[0.9]"
            data-testid="testimonials-heading"
          >
            Don't take our word for it.
          </motion.h2>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-center mt-5 opacity-75 text-white/70 font-body font-light text-sm md:text-base max-w-lg mx-auto"
          >
            Businesses around the world trust EsyAI to build, automate, and scale their digital presence.
          </motion.p>
        </div>
      </div>

      {/* Full-width Animated Columns with Dual Masks */}
      <div className="relative w-full max-w-[100vw] mx-auto z-10 overflow-hidden">
        {/* Vertical mask fade (top/bottom) */}
        <div className="[mask-image:linear-gradient(to_bottom,transparent,black_15%,black_85%,transparent)]">
          {/* Horizontal mask fade (left/right) */}
          <div className="[mask-image:linear-gradient(to_right,transparent,black_5%,black_95%,transparent)] md:[mask-image:linear-gradient(to_right,transparent,black_15%,black_85%,transparent)]">
            <div className="flex justify-center gap-6 max-h-[740px] px-4 min-w-max mx-auto">
              <TestimonialsColumn testimonials={firstColumn} duration={15} />
              <TestimonialsColumn testimonials={secondColumn} className="hidden sm:block" duration={19} />
              <TestimonialsColumn testimonials={thirdColumn} className="hidden lg:block lg:min-w-[320px]" duration={17} />
              <TestimonialsColumn testimonials={firstColumn} className="hidden xl:block xl:min-w-[320px]" duration={21} />
              <TestimonialsColumn testimonials={secondColumn} className="hidden 2xl:block 2xl:min-w-[320px]" duration={16} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
